<template>
  <div>
    <p class=" font-bold text-lg mb-7">
      Account Information
    </p>
    <ValidationObserver rules="required" v-slot="{ handleSubmit }">
      <div class=" w-full">
        <p class=" font-semibold mb-4 inline-block">
          Bank Information
        </p>
        <span
          v-if="!hasSubscriptionExpired() && canUpdateBankInfo"
          class="float-right cursor-pointer text-flame text-base font-semibold"
        >
          <span v-if="!bankEdit" @click="handleClick('bank')">
            <icon
              icon-name="icon-edit"
              size="xs"
              class="cursor-pointer inline-block"
            />
            <span class="pl-2">Edit</span>
          </span>
          <span @click="handleSubmit(saveBankInfo)" v-else>
            <icon
              icon-name="save"
              size="xs"
              class="cursor-pointer inline-block"
            />
            <span class="pl-2">Save</span>
          </span>
        </span>
      </div>
      <div
        class="grid grid-cols-12 gap-6 text-darkPurple"
        style="margin-top:1.125rem"
      >
        <div class="col-span-3">
          <c-select
            placeholder="--Select--"
            :options="banks"
            variant="w-full"
            label="Bank"
            @input="accountInformation.accountNo = null"
            v-model="accountInformation.bank"
            :disabled="!bankEdit"
          />
        </div>
        <div class="col-span-3">
          <c-text
            placeholder="--Enter--"
            label="Account Number"
            v-model="accountInformation.accountNo"
            type="number"
            :rules="numberRule"
            :disabled="!bankEdit || disableNumber || !accountInformation.bank"
          />
          <small v-if="loadingAccount" class="text-xs">Loading...</small>
          <small class=" text-flame font-bold " v-if="error">{{
              `⚠️ ${error}`
            }}</small>
          <small
            class=" text-mediumSeaGreen font-bold"
            v-if="accountInformation.accountName"
          >{{ ` ${accountInformation.accountName} ✅  ` }}</small
          >
        </div>
        <!-- <div class="col-span-3">
          <c-text
            placeholder="--Autofilled---"
            variant="w-full h-10"
            label="Account Name"
            v-model="accountInformation.bvn"
            :disabled="!bankEdit"
          />
        </div> -->
        <!-- <div class="col-span-3">
          <c-text
            placeholder="XXXXXX"
            variant="w-full h-10"
            label="BVN"
            v-model="accountInformation.bvn"
            :disabled="!bankEdit"
          />
        </div> -->
        <div class="col-span-12">
          <divider class="my-4 w-full" />
        </div>
        <div class="col-span-12 w-full">
          <p class=" font-semibold mb-4 inline-block">
            Tax Information
          </p>
          <span
            v-if="!hasSubscriptionExpired() && canUpdateTaxInfo"
            class="float-right cursor-pointer text-flame text-base font-semibold"
          >
            <span @click="handleClick('tax')" v-if="!taxEdit">
              <icon
                icon-name="icon-edit"
                size="xs"
                class="cursor-pointer inline-block"
              />
              <span class="pl-2">Edit</span>
            </span>
            <span @click="saveAccountInfo('tax')" v-else>
              <icon
                icon-name="save"
                size="xs"
                class="cursor-pointer inline-block"
              />
              <span class="pl-2">Save</span>
            </span>
          </span>
        </div>
        <div class="col-span-3">
          <div class="text-sm mb-1 text-jet">
            Tax Authority
          </div>
         <div class="disabled">
            {{
              employeeState
            }}
          </div>
        </div>

        <div class="col-span-3">
          <c-text
            placeholder="--Enter--"
            :label="`${isBasic ? `Employee Tax ID` : !isBasic && accountInformation.employmentType !== 'Independent Contractor' ?
            `Employee Tax ID` : `Tax Identification Number`}`"
            v-model="accountInformation.employeeTaxId"
            :disabled="!taxEdit"
          />
        </div>
        <div v-if="isBasic || (!isBasic && accountInformation.employmentType !== 'Independent Contractor')" class="col-span-12">
          <divider class="my-4 w-full" />
        </div>
      </div>
    </ValidationObserver>
    <div v-if="isBasic || (!isBasic && accountInformation.employmentType !== 'Independent Contractor')">
      <div class="col-span-12 w-full">
        <p class=" font-semibold mb-4 inline-block">
          Pension Information
        </p>
        <span
          v-if="!hasSubscriptionExpired() && canUpdatePFA"
          class="float-right cursor-pointer text-flame text-base font-semibold"
        >
          <span @click="handleClick('pension')" v-if="!pensionEdit">
            <icon
              icon-name="icon-edit"
              size="xs"
              class="cursor-pointer inline-block"
            />
            <span class="pl-2">Edit</span>
          </span>
          <span @click="saveAccountInfo('pension')" v-else>
            <icon
              icon-name="save"
              size="xs"
              class="cursor-pointer inline-block"
            />
            <span class="pl-2">Save</span>
          </span>
        </span>
      </div>
      <div
        class="grid grid-cols-12 gap-6 text-darkPurple"
        style="margin-top:1.125rem"
      >
        <div class="col-span-3">
          <c-select
            placeholder="--Enter--"
            :options="pencom"
            variant="w-full"
            label="PFA"
            v-model="accountInformation.pfaId"
            :disabled="!pensionEdit"
          />
        </div>
        <div class="col-span-3">
          <c-text
            placeholder="--Enter--"
            label="RSA PIN"
            v-model="accountInformation.rsaId"
            :disabled="!pensionEdit"
          />
        </div>
      </div>
    </div>
    <div v-if="isBasic || (!isBasic && accountInformation.employmentType !== 'Independent Contractor')" class="col-span-12">
      <divider class="my-8 w-full" />
    </div>
    <div v-if="isBasic || (!isBasic && accountInformation.employmentType !== 'Independent Contractor')">
      <div class="col-span-12 w-full">
        <p class=" font-semibold mb-4 inline-block">
          NHIS Information
        </p>
        <span
          v-if="!hasSubscriptionExpired() && canUpdateNHISInfo"
          class="float-right cursor-pointer text-flame text-base font-semibold"
        >
          <span @click="handleClick('nhis')" v-if="!NHISEdit">
            <icon
              icon-name="icon-edit"
              size="xs"
              class="cursor-pointer inline-block"
            />
            <span class="pl-2">Edit</span>
          </span>
          <span @click="saveAccountInfo('nhis')" v-else>
            <icon
              icon-name="save"
              size="xs"
              class="cursor-pointer inline-block"
            />
            <span class="pl-2">Save</span>
          </span>
        </span>
      </div>
      <div
        class="grid grid-cols-12 gap-6 text-darkPurple"
        style="margin-top:1.125rem"
      >
        <div class="col-span-3">
          <c-select placeholder="--Select--" :options="NHISOptions" variant="w-full" label="HMO"
            v-model="accountInformation.hmoId" :disabled="!NHISEdit" />
        </div>
        <div class="col-span-3">
          <c-text placeholder="--Enter--" label="Enrollment Number" v-model="accountInformation.hmoEnrollmentNo" :disabled="!NHISEdit"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { ValidationObserver } from "vee-validate";
import { clone } from "lodash";

export default {
  components: {
    ValidationObserver,
    Divider: () => import('@/components/divider'),
    CSelect: () => import("@scelloo/cloudenly-ui/src/components/select"),
    CText: () =>  import("@scelloo/cloudenly-ui/src/components/text"),
  },
  name: "EssAccountInfo",
  data() {
    return {
      bankEdit: false,
      taxEdit: false,
      NHISEdit: false,
      pensionEdit: false,
      disableNumber: false,
      loadingAccount: false,
      error: "",
      states: [],
      numberRule: [
        "required",
        {
          name: "number",
          rule: v => this.validateNumber(v)
        }
      ],
      accountInformation: {
        accountNo: null,
        bank: null,
        accountName: null,
        bvn: null,
        sirs: null,
        rsaId: null,
        pfaId: null,
        employeeTaxId: null,
        hmoEnrollmentNo: null,
        hmoId: null,
        employmentType: ''
      },
      NHISInformation: [],
      employeeTaxState: ""
    };
  },
  computed: {
    ...mapState({
      pencom: state =>
        state.pension.PFAOrgList.map(pension => ({
          id: pension.pfaId,
          name: pension.pfaName
        })),
      employeeDetails: state => state.employee.allEmployeeDetails,
      canUpdateBankInfo: state => state.employee.essPermissions.canUpdateBankInfo,
      canUpdatePFA: state => state.employee.essPermissions.canUpdatePFA,
      canUpdateTaxInfo: state => state.employee.essPermissions.canUpdateTaxInfo,
      canUpdateNHISInfo: state => state.employee.essPermissions.canUpdateNHISInfo,
      hasSubscriptionExpired() {
        return this.$store.getters.hasSubscriptionExpired;
      },
      banks: state =>
        state.Banks.map(bank => ({
          ...bank,
          id: bank.code
        }))
    }),
    isBasic() {
      return (
        this.$store.state.subscription &&
        this.$store.state.subscription.plan === "basic"
      );
    },
    NHISOptions(){
      const options = this.NHISInformation?.map(hmo => (
        {
          id: hmo.hmoId,
          name: hmo.hmoName
        }
       ))
      return options;
    },
    employeeState(){
      return this.employeeTaxState[0]?.name
    }
  },

  methods: {
    validateNumber(value) {
      this.error = "";
      this.accountInformation.accountName = null;
      if (value.toString().length === 10) {
        this.disableNumber = true;
        if (!this.accountInformation.accountName) {
          this.loadingAccount = true;
        }
        this.handleAccountChange(value);
        return true;
      }
      return "Account number must be 10 numbers";
    },
    handleAccountChange(value) {
      this.$_checkAccountNo({
        bankCode: this.accountInformation.bank,
        acctNumber: value
      })
        .then(result => {
          if (result.status === 200) {
            this.error = "";
            this.loadingAccount = false;
            this.disableNumber = false;
            this.accountInformation.accountName = result.data.data.account_name;
          }
        })
        .catch(() => {
          this.loadingAccount = false;
          this.disableNumber = false;
          this.accountInformation.accountName = null;
          this.error = "Incorrect Account number";
        });
    },
    async handleClick(type) {
      try {
        if (type === "bank") {
          this.bankEdit = !this.bankEdit;
        }
        if (type === "tax") {
          this.taxEdit = !this.taxEdit;
        }
        if (type === "pension") {
          this.pensionEdit = !this.pensionEdit;
        }
        if (type === "nhis") {
          this.NHISEdit = !this.NHISEdit;
        }
      } catch (error) {
        this.$toasted.error("You do not have permission to perform this task", {
          duration: 5000
        });
      }
    },
    saveAccountInfo(section) {
      if (section === "bank") {
        this.saveBankInfo();
      }
      if (section === "tax") {
        this.saveTaxInfo();
      }
      if (section === "pension") {
        this.savePensionInfo();
      }
      if (section === "nhis") {
        this.saveNHISInformation();
      }
    },
    saveBankInfo() {
      this.$_saveEmployeeBankInfo({
        userId: this.$AuthUser.id,
        data: {
          bank: this.accountInformation.bank,
          accountNo: this.accountInformation.accountNo,
          bvn: this.accountInformation.bvn
        }
      }).then(() => {
        this.$toasted.success("Account details saved Successfully", {
          duration: 3000
        });
        this.bankEdit = !this.bankEdit;
      });
    },
    saveTaxInfo() {
      this.$_saveEmployeeTaxInfo({
        userId: this.$AuthUser.id,
        data: {
          sirs: this.accountInformation.sirs,
          employeeTaxId: this.accountInformation.employeeTaxId
        }
      }).then(() => {
        this.$toasted.success("Tax information saved Successfully", {
          duration: 3000
        });
        this.taxEdit = !this.taxEdit;
      });
    },
    savePensionInfo() {
      this.$_saveEmployeePensionInfo({
        userId: this.$AuthUser.id,
        data: {
          pfaId: this.accountInformation.pfaId,
          rsaId: this.accountInformation.rsaId
        }
      }).then(() => {
        this.$toasted.success("Pension information saved Successfully", {
          duration: 3000
        });
        this.pensionEdit = !this.pensionEdit;
      });
    },
    saveNHISInformation() {
      this.$_patchEmployeeHMO({
        userId: this.$AuthUser.id,
        data: {
          hmoId: this.accountInformation.hmoId,
          hmoEnrollmentNo: this.accountInformation.hmoEnrollmentNo
        }
      }).then(() => {
        this.$toasted.success("NHIS Information saved Successfully", {
          duration: 3000
        });
        this.NHISEdit = !this.NHISEdit;
      });
    },
  },
  async mounted() {
    await this.$store.dispatch("getBanks");

    this.$_getTaxAuthorities().then(item => {
      this.states = item.data.taxAuthority;
    });
    this.$_getHMO().then(item => {
      this.NHISInformation = item.data.payload;
    });
    await this.$store.dispatch("pension/getPFAOrgList");
    this.accountInformation =  clone(this.employeeDetails);

    this.employeeTaxState = this.states.filter(state => state.taxAuthorityId === this.accountInformation.sirs);
  }
};
</script>

<style></style>
